import { fetchEndpointData } from 'api';
import {
	CHECKOUT_CART_ID_QUERY_PARAM,
	CHECKOUT_VERIFY_REDIRECT_PAYMENT_QUERY_PARAM,
} from 'constants/queryParams';
import type { CartId } from 'types';
import { getPaymentRequest } from 'utils/business-logic';
import { createUrl } from 'utils/url';

import type { PaymentMachineContext } from './payment.types';

/**
 * Make request to start the payment flow.
 *
 * @see: https://apigw-fe-dev01.juladev.se/api/v1/docs/index.html#operations-Cart-post_api_v1_Cart__cartId__payment
 */
export function requestPayment(context: PaymentMachineContext) {
	const { cart } = context;
	if (!cart) {
		throw new Error('Cart is missing');
	}

	return fetchEndpointData({
		name: 'PostCartPayment',
		pathParams: {
			cartId: cart.id,
		},
		body: getPaymentRequest({
			paymentComponentState: context.paymentComponentState,
			// Don't use href since it may contain interfering query variables
			returnUrl: createUrl(`${globalThis.location.origin}/checkout/`, {
				[CHECKOUT_CART_ID_QUERY_PARAM]: cart.id,
				[CHECKOUT_VERIFY_REDIRECT_PAYMENT_QUERY_PARAM]: 'true',
			}),
			selectedPayment: cart.selectedPayment,
		}),
	});
}

/**
 * Make request to finalize the payment (after payment is done).
 *
 * @see: https://apigw-fe-dev01.juladev.se/api/v1/docs/index.html#operations-Cart-post_api_v1_Cart__cartId__finalize
 */
export function finalizePayment(cartId: CartId | undefined) {
	if (!cartId) {
		throw new Error('Cart is missing');
	}
	return fetchEndpointData({
		name: 'PostCartFinalizePayment',
		pathParams: { cartId },
	});
}
